import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Footer from "./Footer";
import "./LockerComplete.css";
import CommonPopup from "./CommonPopup";
import useInactivityRedirect from "./useInactivityRedirect";

const LockerComplete = () => {
  const { t } = useTranslation("lockercomplete");
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState(null);

  const KIOSK_NM = sessionStorage.getItem("KIOSK_NM");

  const {
    showPopup,
    confirmRedirect,
    cancelRedirect,
    remainingSeconds,
  } = useInactivityRedirect({
    inactivityTimeout:  60 * 1000,
    popupTimeout: 15 * 1000,
    redirectTo: "/",
  });

useEffect(() => {
  window.history.pushState(null, "", window.location.href);
  const handlePopState = () => {
    window.history.pushState(null, "", window.location.href);
    navigate("/", { replace: true });
  };
  window.addEventListener("popstate", handlePopState);
  return () => {
    window.removeEventListener("popstate", handlePopState);
  };
}, []);

  useEffect(() => {
    const fromState = location.state;
    if (fromState) {
      setData(fromState);
      sessionStorage.setItem("LockerCompleteData", JSON.stringify(fromState));
    } else {
      const saved = sessionStorage.getItem("LockerCompleteData");
      if (saved) setData(JSON.parse(saved));
    }
  }, [location.state]);

	useEffect(() => {
	  if (data?.lockerOpened && data.mainCode === "R" && sessionStorage.getItem("phoneNumber") && !sessionStorage.getItem("messageSent")) {

	  const phone = sessionStorage.getItem("phoneNumber");
	  const password = sessionStorage.getItem("password");
	  const unitcode = sessionStorage.getItem("UNITCODE");

		fetch("/api/smskakaoSender", {
		  method: "POST",
		  headers: { "Content-Type": "application/json" },
		  body: JSON.stringify({
			phone,
			locker_no: data.lockerNo,
			password,
			start: data.startTime,
			end: data.endTime,
			unitcode,
			message: "[이용자] 보관함이 등록되었습니다."
		  })
		})
		  .then(res => res.json())
		  .then(result => console.log("메시지 전송 결과:", result))
		  .catch(err => console.error("메시지 전송 실패:", err));
	  }
	}, [data]);

  const handleRetry = () => {
    if (!data) return;
	sessionStorage.setItem("messageSent", "true"); // 재시도 시 전송 금지
    alert(t("reopening_message"));
    navigate("/Lockerprocessing", {
      state: {
        mainCode: data.mainCode,
        lockerNo: data.lockerNo,
        retry: true,
      },
    });
  };

  if (!data) return null;

  const { mainCode, lockerNo, lockerOpened } = data;
  const icon = lockerOpened ? "✅" : "⚠️";
  const title = lockerOpened ? t("locker_opened") : t("locker_not_opened");

const description =
  lockerOpened && (mainCode === "F" || mainCode === "O")
    ? t("please_close_door")
    : lockerOpened
    ? t("store_items_safely")
    : t("locker_problem_occurred");

  return (
    <div className="wrap">
      <header style={{ minHeight: "15%"  }}>
        <div className="title" onClick={() => navigate("/")}>
          <h1>{t("completed")}</h1>
        </div>
        <button className="home-button" onClick={() => navigate("/")}>
          Main
        </button>
      </header>

      <main className="content">
        <div className="complete-main">
          <div className="complete-box">
            <div className={`icon ${lockerOpened ? "success" : "fail"}`}>
              {icon}
            </div>
            <h2>{title}</h2>
            <p>{description}</p>

            <div className="locker-info-box">
              <div className="locker-info-row">
                <span className="label">{t("location")} :</span>
                <span className="value">{KIOSK_NM}</span>
              </div>
              <div className="locker-info-row">
                <span className="label">{t("locker_number")} :</span>
                <span className="value">{lockerNo}</span>
              </div>
            </div>
              <>
				{mainCode !== "F" && (
				  <button className="retry-button" onClick={handleRetry}>
					{t("retry_open")}
				  </button>
				)}
				<div className="support-info">
				  {t("contact_support").split("\n").map((line, idx) => (
					<span key={idx}>
					  {line}
					  <br />
					</span>
				  ))}
				  📞 <a href="tel:15992740"><strong>1599-2740</strong></a>
				</div>
              </>
          </div>
        </div>
      </main>

      {showPopup && (
        <CommonPopup
          visible={true}
          message={`${t("continue_question")}<br/><span style="font-weight:700;color:red">(${remainingSeconds} ${t("seconds")})</span>${t("auto_redirect")}`}
          onConfirm={confirmRedirect}
          onClose={cancelRedirect}
          confirmText={t("yes")}
          cancelText={t("no")}
        />
      )}

      <Footer />
    </div>
  );
};

export default LockerComplete;
